<div class="m-toaster">
  @for (toast of toasterService.toasts(); track toast.id) {
    <div class="m-toaster__item m-toaster__item--{{ toast.type }}">
      <div class="m-toaster__icon">
        @switch (toast.type) {
          @case ('success') {
            <mat-icon>check_circle</mat-icon>
          }
          @case ('error') {
            <mat-icon>error</mat-icon>
          }
          @case ('warning') {
            <mat-icon>warning</mat-icon>
          }
          @case ('info') {
            <mat-icon>info</mat-icon>
          }
        }
      </div>
      <span class="m-toaster__message">{{ toast.message }}</span>
      <button class="m-toaster__close" (click)="toasterService.remove(toast.id)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>
